export const SOURCE_TYPE = {
  POPUP: 'POPUP',
  NAG: 'NAG',
  DEFAULT: 'DEFAULT',
};
